import standardAPI from '@/api/standard_items';

const responseUrl = '/world-tours/requests';

const state = {
  requests: [],
  requests_MetaData: {},
  requests_status: '',
  requests_page: 1,
  requests_perPage: 10,
};

const getters = {
  get_requests: (state) => {
    return state.requests;
  },
  get_requests_status: (state) => {
    return state.requests_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_requests ({ commit }, getOptions) {
    commit('DATA_REQUESTS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_REQUESTS_UPDATE_SUCCESS', response);
            commit('DATA_REQUESTS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_REQUESTS_READY');
            reject(response);
          } else {
            commit('DATA_REQUESTS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_requests_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  change_request_status ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/' + itemData.id + '/change-status',
      method: 'put',
    };
    return new Promise((resolve, reject) => {
      standardAPI.universal_response(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.requests_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.requests_perPage = max;
  },
  DATA_REQUESTS_READY: (state) => {
    state.requests_status = 'ready';
  },
  DATA_REQUESTS_REQUEST: (state) => {
    state.requests_status = 'loading';
  },
  DATA_REQUESTS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.requests_MetaData.meta = response.meta;
      state.requests_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.requests = response.data || [];
    }
    state.requests_status = 'success';
  },
  DATA_REQUESTS_ERROR: (state) => {
    state.requests_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
